import { useState, useEffect } from 'react';

import useFetch, { CachePolicies } from 'use-http';

import { API_ROUTES } from '../../constants';

import {
  APIResponseDocumentationsType,
  DocumentationsDataType,
  TDocumentationState,
} from './documentations.types';

export const useAPIFetchApplicationDocumentations = (
  applicationId: string
): APIResponseDocumentationsType => {
  const { get, post, put, error, loading, response } = useFetch(
    API_ROUTES.APPLICATIONS,
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const [responseData, setResponseData] = useState<TDocumentationState>({
    loaded: false,
    data: {} as DocumentationsDataType,
  });

  async function fetchDocumentations(applicationId: string): Promise<void> {
    const { data } = await get(`${applicationId}/documentations`);

    setResponseData({ loaded: true, data: data ? data : {} });
  }

  async function addDocumentations(
    applicationId: string,
    postedData: TDocumentationState
  ): Promise<void> {
    const { data } = await post(`${applicationId}/documentations`, postedData);

    setResponseData({ loaded: true, data: data ? data : {} });
  }

  async function updateDocumentations(
    applicationId: string,
    updatedData: TDocumentationState
  ): Promise<void> {
    const { data } = await put(`${applicationId}/documentations`, updatedData);

    setResponseData({ loaded: true, data: data ? data : {} });
  }
  useEffect(() => {
    fetchDocumentations(applicationId);
    // eslint-disable-next-line
  }, []);

  return {
    data: responseData.data,
    loading,
    error,
    loaded: response.ok,
    fetchDocumentations,
    addDocumentations,
    updateDocumentations,
  };
};
